import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Filo olayları (Prompt 17, ADR 0017 §13–17). Yük KİŞİSEL VERİ TAŞIMAZ: plaka, sürücü adı / telefonu yoktur; araç ve
 * cari kimlikleri taşınır, ayrıntıyı isteyen istemci yetki denetimli uçtan çeker. Tutarlar kuruş, litre 3 ondalık dizge.
 */
export const fleetRuleViolatedV1 = defineEvent({
    type: "fleet.rule.violated",
    version: 1,
    description: "Filo kuralı ihlal edildi (elle filo fişinde yetkili onayıyla geçildi ya da kasa satışında sunucu yeniden denetimi)",
    realtime: ["station", "tenant"],
    payload: z.object({
        companyId: z.uuid(),
        stationId: z.uuid(),
        counterpartyId: z.uuid(),
        vehicleId: z.uuid().nullable(),
        source: z.enum(["SHIFT_CREDIT_SALE", "POS_SALE"]),
        sourceId: z.uuid(),
        action: z.enum(["BLOCK", "APPROVAL"]),
        overridden: z.boolean(),
        violationCodes: z.array(z.string()),
        amount: z.string().describe("Kuruş"),
        litres: z.string(),
        occurredAt: z.iso.datetime({ offset: true }),
    }),
});
export const fleetBillingIssuedV1 = defineEvent({
    type: "fleet.billing.issued",
    version: 1,
    description: "Filo dönem faturası kesildi (fişli satış faturası; gelir / KDV / açık kalem üretmez)",
    realtime: ["tenant"],
    payload: z.object({
        runId: z.uuid(),
        companyId: z.uuid(),
        counterpartyId: z.uuid(),
        periodFrom: z.iso.date(),
        periodTo: z.iso.date(),
        invoiceId: z.uuid(),
        invoiceNo: z.string().nullable(),
        totalAmount: z.string(),
        receiptCount: z.number().int(),
    }),
});
export const fleetBillingCancelledV1 = defineEvent({
    type: "fleet.billing.cancelled",
    version: 1,
    description: "Filo dönem faturası iptal edildi; kullanım satırları yeniden faturalanabilir",
    realtime: ["tenant"],
    payload: z.object({
        runId: z.uuid(),
        companyId: z.uuid(),
        counterpartyId: z.uuid(),
        periodFrom: z.iso.date(),
        periodTo: z.iso.date(),
        invoiceId: z.uuid().nullable(),
        reason: z.enum(["MANUAL", "INVOICE_CANCELLED"]),
    }),
});
export const fleetVehicleRequestCreatedV1 = defineEvent({
    type: "fleet.vehicle_request.created",
    version: 1,
    description: "Filo portalından araç ekleme talebi geldi (personel onayı bekliyor)",
    realtime: ["tenant"],
    payload: z.object({ requestId: z.uuid(), counterpartyId: z.uuid() }),
});
export const fleetVehicleRequestDecidedV1 = defineEvent({
    type: "fleet.vehicle_request.decided",
    version: 1,
    description: "Araç ekleme talebi karara bağlandı (onayda araç açıldı)",
    realtime: ["tenant"],
    payload: z.object({
        requestId: z.uuid(),
        counterpartyId: z.uuid(),
        decision: z.enum(["APPROVED", "REJECTED"]),
        vehicleId: z.uuid().nullable(),
    }),
});
//# sourceMappingURL=fleet.v1.js.map